"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlUserDefinedFields = void 0;
var React = require("react");
var userDefinedField_1 = require("../userDefinedField");
var mobx_react_1 = require("mobx-react");
var ControlUserDefinedFields = (function (_super) {
    __extends(ControlUserDefinedFields, _super);
    function ControlUserDefinedFields() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlUserDefinedFields.prototype.get_values_of_type = function (udf_type) {
        if (this.props.udf_values == null)
            return [];
        return this.props.udf_values.filter(function (iFieldValue) {
            return iFieldValue.field_type.id == udf_type.id;
        });
    };
    ControlUserDefinedFields.prototype.updateCustomField = function (udf_type, udf_values) {
        var custom_values = this.props.udf_values;
        if (custom_values) {
            custom_values = custom_values.filter(function (custom_value) {
                return custom_value.field_type.id != udf_type.id;
            });
        }
        else
            custom_values = [];
        custom_values = custom_values.concat(udf_values);
        this.props.onChange("udf_values", custom_values);
    };
    ControlUserDefinedFields.prototype.render = function () {
        var fieldTypes = this.props.udf_types;
        var end_col = fieldTypes.length % 2;
        var field_counter = 0, field_rows = [];
        for (var i = 0; i < fieldTypes.length; i += 2) {
            field_rows.push(React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-6" },
                    React.createElement(userDefinedField_1.UserDefinedField, { udf_type: fieldTypes[i], udf_values: this.get_values_of_type(fieldTypes[i]), target_object_id: this.props.target_object_id, onChange: this.updateCustomField.bind(this), render: userDefinedField_1.UDFRenderKind.STACKED })),
                i < fieldTypes.length - 1 ?
                    React.createElement("div", { className: "col-6" },
                        React.createElement(userDefinedField_1.UserDefinedField, { udf_type: fieldTypes[i + 1], udf_values: this.get_values_of_type(fieldTypes[i + 1]), target_object_id: this.props.target_object_id, onChange: this.updateCustomField.bind(this), render: userDefinedField_1.UDFRenderKind.STACKED }))
                    :
                        React.createElement("div", { className: "col-6 text-right" }, this.props.children)));
        }
        if (end_col == 0) {
            field_rows.push(React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-6" }),
                React.createElement("div", { className: "col-6 text-right" }, this.props.children)));
        }
        return (React.createElement("div", { className: "ControlInformationForm__UserDefined" }, field_rows));
    };
    ControlUserDefinedFields = __decorate([
        mobx_react_1.observer
    ], ControlUserDefinedFields);
    return ControlUserDefinedFields;
}(React.Component));
exports.ControlUserDefinedFields = ControlUserDefinedFields;
